import React from "react";
import { List, ListItem, ListItemIcon, ListItemText, Toolbar, Box, Typography, Chip } from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import HistoryIcon from "@mui/icons-material/History";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import HelpIcon from "@mui/icons-material/Help";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import { useNavigate, useLocation } from "react-router-dom";
import { useData } from "../ContextApi/ContextProvider";

const menuItems = [
  { text: "Dashboard", icon: <DashboardIcon />, path: "/dashboard" },
  { text: "History", icon: <HistoryIcon />, path: "/history" },
  { text: "Buyers", icon: <PeopleAltIcon />, path: "/buyers" },
  { text: "Design", icon: <DesignServicesIcon />, path: "/design" },
  { text: "FAQs", icon: <HelpIcon />, path: "/faqs" },
  // { text: "Settings", icon: <SettingsIcon />, path: "/settings" },
];

const Sidebar = ({ onNavigate }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (path) => {
    navigate(path);
    if (onNavigate) onNavigate();
  };
  const { globalData } = useData();
  return (
    <Box
      sx={{
        height: "100vh",
        background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 52%, #eef6ff 100%)",
        borderRight: "1px solid rgba(148, 163, 184, 0.22)",
        overflow: "hidden",
        minWidth: { xs: 72, sm: 248 },
        position: "relative",
        "&:after": {
          content: '""',
          position: "absolute",
          left: 24,
          right: 24,
          bottom: 24,
          height: 120,
          borderRadius: 3,
          background: "linear-gradient(135deg, rgba(37,99,235,0.12), rgba(16,185,129,0.12))",
          pointerEvents: "none",
        },
      }}
    >
      <Toolbar sx={{ minHeight: { xs: 60, sm: 64 }, px: 2.5 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
          <Box
            sx={{
              width: 38,
              height: 38,
              borderRadius: 2,
              background: "linear-gradient(135deg, #2563eb, #0f766e)",
              color: "#fff",
              display: "grid",
              placeItems: "center",
              fontWeight: 900,
              boxShadow: "0 10px 24px rgba(37, 99, 235, 0.28)",
            }}
          >
            K
          </Box>
          <Box>
            <Typography sx={{ fontWeight: 900, color: "#111827", lineHeight: 1 }}>
              KonnectFBR
            </Typography>
            <Typography sx={{ fontSize: 12, color: "#6b7280", mt: 0.25 }}>
              Invoice workspace
            </Typography>
          </Box>
        </Box>
      </Toolbar>
      <List sx={{ px: 1.5, pt: 1 }}>
      {menuItems.map((item) => {
  const active = location.pathname === item.path;

  return (
    <ListItem
      button
      key={item.text}
      selected={active}
      onClick={() => handleClick(item.path)}
      sx={{
        my: 0.35,
        borderRadius: 2,
        px: 1.5,
        py: 1.15,
        background: active ? "linear-gradient(135deg, #eef2ff, #ecfeff)" : "transparent",
        border: active ? "1px solid #bfdbfe" : "1px solid transparent",
        boxShadow: active ? "0 10px 24px rgba(37, 99, 235, 0.09)" : "none",
        transition: "background 0.2s, border-color 0.2s, color 0.2s, box-shadow 0.2s",
        "&:hover": {
          background: active ? "linear-gradient(135deg, #eef2ff, #ecfeff)" : "#f8fafc",
        },
      }}
    >
      <ListItemIcon
        sx={{
          minWidth: 38,
          color: active ? "#2563eb" : "#64748b",
          transition: "color 0.2s",
        }}
      >
        {item.icon}
      </ListItemIcon>
      <ListItemText
        primary={
          <span
            style={{
              fontWeight: active ? 800 : 650,
              color: active ? "#1e3a8a" : "#334155",
              letterSpacing: 0,
              fontSize: "0.96rem",
            }}
          >
            {item.text}
          </span>
        }
      />
    </ListItem>
  );
})}

      </List>
      <Box sx={{ position: "absolute", left: 20, right: 20, bottom: 26, zIndex: 1 }}>
        <Chip
          label={globalData?.is_prod_token === 1 ? "Production connected" : "Sandbox connected"}
          sx={{
            width: "100%",
            justifyContent: "center",
            bgcolor: globalData?.is_prod_token === 1 ? "#dcfce7" : "#dbeafe",
            color: globalData?.is_prod_token === 1 ? "#047857" : "#1d4ed8",
            fontWeight: 900,
          }}
        />
      </Box>
    </Box>
  );
};

export default Sidebar;
